import { useDispatch, useSelector } from "react-redux";
import {
  getQuizQuestions,
  setQuestionForm,
  setState,
  updateQuestion,
} from "./redux/lawCollegeSlice";

export default function EditOrViewLawCollegeQuiz() {
  const { questionForm, mode } = useSelector((state) => state.lawCollegeQuiz);
  const userStr = localStorage.getItem("user");
  const userId = userStr
    ? JSON.parse(userStr)?.id
    : JSON.parse(userStr)?.user_id
    ? null
    : "";
  const dispatch = useDispatch();
  const {
    questionId,
    question,
    option_a,
    option_b,
    option_c,
    option_d,
    correct_option,
    difficulty_level,
    created_by,
    created_at,
    updated_by,
    updated_at,
    created_by_user_id,
    updated_by_user_id,
  } = questionForm;

  const isViewMode = mode === "view"; // 🔹 key change

  const optionFields = [
    { label: "Option A", key: "option_a", value: option_a },
    { label: "Option B", key: "option_b", value: option_b },
    { label: "Option C", key: "option_c", value: option_c },
    { label: "Option D", key: "option_d", value: option_d },
    { label: "Correct Option", key: "correct_option", value: correct_option },
    {
      label: "Select Question Level",
      key: "difficulty_level",
      value: difficulty_level,
      isSelect: true,
    },
  ];

  const handleChange = (key, value) => {
    dispatch(setQuestionForm({ key, value }));
  };
  function formatDate(date) {
    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short", // or "long"
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  const handleSubmit = async () => {
    if (window.confirm("Are you sure to update the question details ?")) {
      try {
        const res = await dispatch(
          updateQuestion({
            id: questionId,
            content: question,
            level: difficulty_level,
            correct_option,
            updated_by: Number(userId),
            options: {
              A: option_a,
              B: option_b,
              C: option_c,
              D: option_d,
            },
          })
        ).unwrap();

        alert("Question updated successfully.", res && JSON.stringify(res));
        window.location.reload();
        dispatch(setState({ key: "openPopUp", value: false }));
        dispatch(getQuizQuestions());
      } catch (error) {
        if (error?.response?.status === 409) {
          alert("This question already exists.");
        } else {
          alert(
            "Failed to add question: " + (error?.message || "Unknown error")
          );
        }
        console.error("Error adding question:", error);
      }
    }
  };
  return (
    <div>
      <div>
        {/* <div className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4"> */}
        {/* Full-width Question input */}
        <div className="row mb-3">
          <label className="col-sm-3 col-form-label font-medium text-gray-700">
            Question
          </label>
          <div className="col-sm-12">
            <input
              type="text"
              className="form-control"
              value={question}
              onChange={(e) => handleChange("question", e.target.value)}
              disabled={isViewMode} // 🔹 Disable in view mode
            />
          </div>
        </div>

        {/* 2-in-a-row layout for remaining fields */}
        <div className="row">
          {optionFields.map((field) => (
            <div className="col-md-6 mb-3" key={field.key}>
              <label className="form-label text-gray-700 font-medium">
                {field.label}
              </label>
              {field.isSelect ? (
                <select
                  className="form-control"
                  value={field.value}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                  disabled={isViewMode} // 🔹 Disable select too
                >
                  <option value="">-- Select Level --</option>
                  <option value="basic">Basic Level</option>
                  <option value="advanced">Advanced Level</option>
                  <option value="ultra">Ultra Level</option>
                  <option value="docmaster">Docmaster</option>
                </select>
              ) : (
                <input
                  type="text"
                  className="form-control"
                  value={field.value}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                  disabled={isViewMode} // 🔹 Disable text input
                />
              )}
            </div>
          ))}
          {isViewMode && (
            <div>
              {/* Row 1 */}

              <div style={{ display: "flex", gap: "10%" }}>
                <label className="form-label text-gray-700 font-medium">
                  Created By:{" "}
                  <span className="font-normal">
                    {created_by || "-"}({created_by_user_id})
                  </span>
                </label>
                <label className="form-label text-gray-700 font-medium">
                  Created At:{" "}
                  <span className="font-normal">
                    {created_at ? formatDate(created_at) : "-"}
                  </span>
                </label>
              </div>

              {/* Row 2 */}
              <div style={{ display: "flex", gap: "10%" }}>
                <label className="form-label text-gray-700 font-medium">
                  Updated By:{" "}
                  <span className="font-normal">
                    {updated_by || "-"} ({updated_by_user_id})
                  </span>
                </label>
                <label className="form-label text-gray-700 font-medium">
                  Updated At:{" "}
                  <span className="font-normal">
                    {updated_at ? formatDate(updated_at) : "-"}
                  </span>
                </label>
              </div>
            </div>
          )}
        </div>

        {!isViewMode && (
          <div className="text-center mt-4">
            <button
              className="btn btn-primary px-4 py-2 rounded"
              onClick={() => handleSubmit()}
            >
              Update{" "}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
